import { render, staticRenderFns } from "./RecemNascidoCollapse.vue?vue&type=template&id=550c5497&scoped=true&"
import script from "./RecemNascidoCollapse.vue?vue&type=script&lang=js&"
export * from "./RecemNascidoCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c5497",
  null
  
)

export default component.exports